import { Create, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from "react-admin";
import { PERMISSIONS } from "../../constants";
import { getChainId } from "../../lib";
import { Permission } from "../../components";

const CityCreate = () => (
  <Create title="Adicionar cidade" redirect="list">
    <SimpleForm defaultValues={{ chainId: getChainId() }} sx={{ maxWidth: 600 }}>
      {Permission({
        permission: PERMISSIONS.ADMIN,
        children: (
          <ReferenceInput
            reference="chains"
            source="chainId"
            sort={{ field: 'name', order: 'ASC' }}
            //@ts-ignore
            perPage={false}
          >
            <SelectInput
              sx={{ minWidth: 300 }}
              label="Rede"
              optionText="name"
              isRequired
            />
          </ReferenceInput>
        )
      })}
      <TextInput sx={{ minWidth: 300 }} source="name" label="Nome" placeholder="Belo Horizonte - MG" validate={required()} />
    </SimpleForm>
  </Create>
);

export default CityCreate;
